import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import JavaScriptEmbed from 'components/consumer/HtmlEmbed/JavaScriptEmbed';
import CustomProductList from 'components/consumer/CustomProductList/';

const PROJECT_SIMON_PAGE_CONFIG = {
  customListSlug: 'pantone-dec-2024',
  pageTitle: 'Joybird x Pantone',
  syndecaCatalogKey: 'joybird-x-pantone',
  syndecaGuideKey: '82ADE6DA-AF98-1341-AC8B-66A9BBAAC9E7',
};

const ProjectSimonPage = ({ isAdmin }) => {
  if (isAdmin) {
    return <AdminPlaceholder>ProjectSimonPage component</AdminPlaceholder>;
  }

  if (!PROJECT_SIMON_PAGE_CONFIG) {
    return null;
  }

  return (
    <>
      {!!PROJECT_SIMON_PAGE_CONFIG?.pageTitle && (
        <Helmet>
          <title>{PROJECT_SIMON_PAGE_CONFIG?.pageTitle}</title>
        </Helmet>
      )}

      {!!PROJECT_SIMON_PAGE_CONFIG?.syndecaCatalogKey &&
        !!PROJECT_SIMON_PAGE_CONFIG?.syndecaGuideKey && (
          <>
            <div id="syndeca" style={{ height: '685px' }} />
            <JavaScriptEmbed
              js={`<script
                 id="syndeca-embed-script"
                 type="text/javascript"
                 src="//viewer.syndeca.com/scripts/syndeca-embed.js"
                 data-guide-key=${PROJECT_SIMON_PAGE_CONFIG?.syndecaGuideKey}
                 data-catalog-key=${PROJECT_SIMON_PAGE_CONFIG?.syndecaCatalogKey}
                 ></script>
            `}
            />
          </>
        )}

      {!!PROJECT_SIMON_PAGE_CONFIG?.customListSlug && (
        <div className="my-4">
          <CustomProductList
            config={{
              listStyle: PROJECT_SIMON_PAGE_CONFIG?.customListStyle || 'Slide',
              filterByStock: false,
              sortByPopularity: false,
              showProductFilters: false,
              elementAttribute: {
                id: 'project-simon-page-cl',
              },
              showFabricOrLeather: false,
              toggleSourceType: {
                manualListId: '',
                selected: {
                  value: 'CustomListInput',
                },
                customListSlug: PROJECT_SIMON_PAGE_CONFIG?.customListSlug,
              },
              listCardSize: {
                cardSizeSelected:
                  PROJECT_SIMON_PAGE_CONFIG?.customListCardStyle || 'medium',
              },
            }}
          />
        </div>
      )}
    </>
  );
};

ProjectSimonPage.propTypes = {
  isAdmin: PropTypes.bool,
};

export default ProjectSimonPage;
